import { useState, useCallback, useMemo } from 'react';
import { Winning } from '../types/prize.types';
import { SORT_TYPE } from '../constants/sort';
import { sortPrizes, isValidSortType, getDefaultSortType } from '../utils/prizeSortUtils';

interface UsePrizeSortReturn {
    sortedPrizes: Winning[];
    currentSortType: SORT_TYPE;
    setSortType: (sortType: SORT_TYPE) => void;
    sortOptions: Array<{ value: SORT_TYPE; label: string }>;
}

export const usePrizeSort = (
    prizes: Winning[],
    initialSortType: SORT_TYPE = getDefaultSortType()
): UsePrizeSortReturn => {
    const [currentSortType, setCurrentSortType] = useState<SORT_TYPE>(initialSortType);

    const setSortType = useCallback((sortType: SORT_TYPE) => {
        if (isValidSortType(sortType)) {
            setCurrentSortType(sortType);
        } else {
            console.warn(`Invalid sort type: ${sortType}`);
        }
    }, []);

    const sortedPrizes = useMemo(() => {
        if (!prizes || prizes.length === 0) {
            return [];
        }
        return sortPrizes(prizes, currentSortType);
    }, [prizes, currentSortType]);

    const sortOptions = useMemo(
        () => [
            { value: SORT_TYPE.MOST_RECENT, label: 'Most Recent' },
            { value: SORT_TYPE.GAME_TITLE, label: 'Game Title' },
            { value: SORT_TYPE.UNPAID_TO_PAID, label: 'Unpaid to Paid' },
            { value: SORT_TYPE.PAID_TO_UNPAID, label: 'Paid to Unpaid' }
        ],
        []
    );

    return {
        sortedPrizes,
        currentSortType,
        setSortType,
        sortOptions
    };
};

export default usePrizeSort;
